import React from 'react'
import {Formik} from 'formik'
import {connect} from 'react-redux'
import {withRouter, Link} from 'react-router-dom'
import { CSSTransition } from "react-transition-group"
import {resetPassword} from '../actions/auth'
import * as qs from 'query-string';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            formState: 'INITIAL',
            isEmailSubmitted: false,
            isCodeSubmitted:false,
            gotErrors: false,       // Will trigger the error message to display if TRUE
            success: false,         // Will trigger the Success message to display if TRUE
            errorMsg: '',           // Dynamic message depending on what type of error
            successMsg: '',         // The success message if everything is A OK
            curretPassError: false  // Will trigger to TRUE if the return object of changePassword() has an error OR invalid current password 
        }

        this.renderMessage = this.renderMessage.bind(this)

    }

    renderMessage = () => {
        if (this.state.gotErrors) {
          setTimeout(() => {
            this.setState({
              gotErrors: false,
              curretPassError: false,
              newPassError: false
            })
          }, 3000)
    
          return this.state.errorMsg
    
        }
    
        if (this.state.success) {
          setTimeout(() => {
            this.setState({
              success: false,
              curretPassError: false,
              newPassError: false
            })
          }, 3000)
    
          return this.state.successMsg
        }
    
      }

    render(){
        let {
            dispatch
        } = this.props
        let param = qs.parse(this.props.location.search)
        let {
            formState,
            isEmailSubmitted,
            isCodeSubmitted
        } = this.state

        const NotificationMessage = {
            INITIAL: {
                message: "We will send a reset code to this email",
                alertClass: "alert-primary"
            },
            SUCCESS: {
                message: "The password reset code has been sent to your email, please check your email inbox or spam folder",
                alertClass: "alert-success"
            },
            ERROR: {
                message: "There was an error in sending the password reset code",
                alertClass: "alert-danger"
            }
        }

        return (
            <div>
                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={5000}
                    classNames="fade"
                >
                <div className="forgot-center-wrapper">
                
                <div className="forgot-center-div">
                    <Formik
                        initialValues={{email: '', newPassword:'',confirmNewPassword:''}}
                        onSubmit={values => {

                            if(values.newPassword != values.confirmNewPassword){
                                this.setState({
                                    errorMsg: 'Password is not the same',
                                    gotErrors: true,
                                    curretPassError: true
                                })
                            }else if(values.newPassword == values.confirmNewPassword){
                                dispatch(resetPassword(encodeURIComponent(values.newPassword),param.id))
                                .then(({response}) => {
                                    // console.log("response",response)
                                    if(response.ok){
                                        this.setState({
                                            successMsg: `Password changed successfully`,
                                            success: true
                                        })

                                        setTimeout(() => {
                                            this.props.history.push('/')
                                            setTimeout(() => {
                                              window.location.reload()
                                            }, 500)
                                          }, 1000)
                                    } 
                                })

                                
                            }

                            
                        }}
                        
                        render={({
                            handleSubmit,
                            handleChange,
                            values
                        }) => (
                            <div className="login-view-wrapper">
                                <form
                                    onSubmit={handleSubmit}
                                    className="container"
                                >
                                    <div className='form-group'>
                                    <CSSTransition
                                            in={true}
                                            timeout={500}
                                            classNames="fade" 
                                    >
                                        <div className={`col s12 waves-effect pulse alert align-center ${NotificationMessage[formState].alertClass}`}>
                                            <span>Enter your New Password</span>
                                        </div>
                                    </CSSTransition>
                                    </div>
                                    <div className='form-group'>
                                    <div className="form-group">
                                  <label htmlFor="new-password">New Password</label>
                                  <input
                                    type="password"
                                    onChange={handleChange}
                                    name="newPassword"
                                    className={`form-control `}
                                    required
                                  />
                                </div>
                                <div className="form-group">
                                  <label htmlFor="confirm-new-password">Confirm New Password</label>
                                  <input
                                    type="password"
                                    onChange={handleChange}
                                    name="confirmNewPassword"
                                    className={`form-control `}
                                    autoComplete="off"
                                    required
                                  />
                                </div>
                                <div className="form-group">
                                  <button
                                    type="submit"
                                    onChange={handleChange}
                                    value="Change Password"
                                    name="confirmNewPassword"
                                    className="btn btn-primary btn-block"
                                    autoComplete="off"
                                  >Change Password</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        )}
                    />
                </div>

                <div className="text-center">
                    <h4>
                    <span className={`text-${this.state.gotErrors ? 'danger' : this.state.success ? 'success' : ''}`}>
                        {this.renderMessage()}
                    </span>
                    </h4>
                </div>
            </div></CSSTransition>
        </div>//End of entire wrapping Div
        )
    }
}

function mapStateToProps(){
    return {}
}

export default withRouter(connect(mapStateToProps)(ResetPassword))


// WEBPACK FOOTER //
// ./src/components/resetPassword.js